import { Request } from "./request";

export function getSupervisorList(): Request {
  return {
    url: "/api/statistic/organization/supervise",
    method: "GET",
  };
}
